import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, DestroyRef, Input, QueryList, ViewChildren } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { IAssessmentExtended, IProfile, IResponse } from '@interfaces/index';
import { AppService } from '@ui-components/services';
import { AssessmentService } from '../../services/assessment.service';
import { DashboardService } from '../../services/dashboard.service';
import { ReportDownloadService } from '../../services/report-download.service';

@Component({
  selector: 'app-my-assessments',
  templateUrl: './my-assessments.component.html',
  styleUrl: './my-assessments.component.scss'
})
export class MyAssessmentsComponent {

  MY_ASSESSMENT_COLUMNS = {
    NAME: 'name',
    STATUS: 'status',
    ITERATION: 'iteration',
    COMPLETE: 'complete_by',
    ACTIONS: 'actions'
  };

  MY_ASSESSMENT_COLUMN_KEYS = Object.values(this.MY_ASSESSMENT_COLUMNS);

  MY_ASSESSMENT_COLUMNS_MOBILE_VIEW = {
    NAME: 'name',
    STATUS: 'status',
    ACTIONS: 'actions'
  };

  MY_ASSESSMENT_COLUMNS_MOBILE_VIEW_KEYS = Object.values(this.MY_ASSESSMENT_COLUMNS_MOBILE_VIEW);

  downloadingId: number | null = null;
  isExpanded: boolean = false;
  isMobileView: boolean = false;
  loading = false;
  my_assessments: IAssessmentExtended[] = [];

  @Input() profile: IProfile | null = null;
  @ViewChildren(MatMenuTrigger) triggers!: QueryList<MatMenuTrigger>;

  get isSuperAdmin(): boolean {
    if (this.profile) {
      return this.profile.role_id === 1
    }
    return false
  }

  constructor(
    protected _app_service: AppService,
    protected _assessment_service: AssessmentService,
    protected _breakpointObserver: BreakpointObserver,
    protected _dashboard_service: DashboardService,
    protected _report_download_service: ReportDownloadService,
    protected _router: Router,
    private _destroy_ref: DestroyRef
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData(): void {
    this.loading = true;
    this._breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobileView = result.matches;
    });

    this._assessment_service.getMyAssessments().subscribe(
      (response: IResponse<IAssessmentExtended[]>) => {
        this.my_assessments = response.data;
        this.loading = false;
      }
    );
  }

  approve(assessment: IAssessmentExtended) {
    this._assessment_service.approve(assessment).subscribe(
      (response: IResponse<{}>) => {
        this._app_service.notify('Your request successful', 'success');
        this.loadData();
      }
    )
  }

  complete(assessment: IAssessmentExtended) {
    this._dashboard_service.complete(assessment);
  }

  downloadReport(assessment: IAssessmentExtended) {
    this.downloadingId = assessment.org_person_assessment_id;
    this._report_download_service.downloadReport(assessment.org_person_assessment_id).pipe(
      finalize(() => this.downloadingId = null),
      takeUntilDestroyed(this._destroy_ref)
    ).subscribe({
      error: () => this._app_service.notify('Could not prepare the report — try again.', 'error')
    });
  }

  goToProfile() {
    this._dashboard_service.goToProfile();
  }


  view(assessment: IAssessmentExtended) {
    this._dashboard_service.view(assessment)
  }

  viewRow(assessment: IAssessmentExtended, rowIndex: number) {
    if (assessment.completed_at) {
      this.view(assessment);
    }
    else {
      // Close any currently open menus
      this.triggers.forEach((trigger, index) => {
        if (trigger.menuOpen && index !== rowIndex) {
          trigger.closeMenu();
        }
      });
      // Open the selected row's menu
      const trigger = this.triggers.toArray()[rowIndex];
      if (trigger && !trigger.menuOpen) {
        trigger.openMenu();
      }
    }
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

}
